export default __webpack_public_path__ + "static/media/fingerprint.6efb0463.png";